<template>
  <div>
    <div class="sp_wrap">
      <ul>
        <li v-for="item in spList" :key="item.id" @click="playVideo(item)">
          <template>
            <img :src="item.image" alt="" class="poster-img" v-if="item.image" />
            <video :src="item.files" v-else></video>
          </template>
          <div class="sp_title">
            <div class="sp_title-title">
              {{ item[`${currentLang.prefix}title`] }}
            </div>
            <div class="sp_title-copy" @click.stop="copy(item.files)">
              <i class="el-icon-copy-document"></i>
              {{ productPage.copyText }}
            </div>
          </div>
          <div
            class="sp_desc"
            v-html="item[`${currentLang.prefix}content`]"
          ></div>
          <div class="sp_time">
            <span>上传时间：</span>
            <span>{{ item.publish_time_txt }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="sc_pagi">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <div slot="title" style="display: flex">
        <div class="el-dialog__title" style="margin-right: 10px">
          {{ title }}
        </div>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-document-copy"
          @click="copy()"
          >{{ productPage.copyText }}</el-button
        >
      </div>
      <custom-video
        :url="videoUrl"
        :poster="currentInfo.image ? currentInfo.image : ''"
      ></custom-video>
    </el-dialog>
  </div>
</template> 


<script>
import { companyVideoList, getArticleList } from "@/utils/http.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      spList: [],
      page: 1,
      total: 0,
      dialogVisible: false,
      videoUrl: "",
      title: "",
      currentInfo: {},
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    productPage() {
      return this.currentLang.config.productPage
    }
  },

  mounted() {
    this.fetchVideoList();
  },

  methods: {
    getProductNameList() {
      companyVideoList({ page: this.page, limit: 6 }).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.total = res.data.count;
          this.spList = res.data.list;
        }
      });
    },
    fetchVideoList() {
      const query = {
        cate_id: 39,
        page: this.page,
        limit: 6,
      }
      getArticleList(query).then((res) => {
        if (res.code === 1) {
          this.total = res.data.count;
          this.spList = res.data.list;
        }
      });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.fetchVideoList();
    },
    playVideo(item) {
      this.currentInfo = item;
      this.title = item[`${this.currentLang.prefix}title`];
      this.videoUrl = item.files;
      this.dialogVisible = true;
      // this.$refs.vueRef.play();//播放
    },
    handleClose() {
      this.videoUrl = "";
      this.dialogVisible = false;
    },
    copy(videoUrl) {
      navigator.clipboard
        .writeText(videoUrl ? videoUrl : this.videoUrl)
        .then(() => {
          this.$message.success("链接复制成功");
        })
        .catch(() => {
          this.$message.error("链接复制失败");
        });
    },

    formatDate(date, format = "yyyy-MM-dd HH:mm") {
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
      let hour = String(date.getHours()).padStart(2, "0");
      let minute = String(date.getMinutes()).padStart(2, "0");
      let second = String(date.getSeconds()).padStart(2, "0");

      let obj = {
        "M+": month, // 月份
        "d+": day, // 日
        "h+": hour, // 小时
        "m+": minute, // 分
        "s+": second, // 秒
        yyyy: year, // 年份
        MM: month,
        dd: day,
        HH: hour,
        mm: minute,
        ss: second,
      };

      for (let k in obj) {
        if (new RegExp(`(${k})`).test(format)) {
          format = format.replace(
            RegExp.$1,
            obj[k]
          );
        }
      }
      return format;
    },
  },
};
</script>
<style lang="scss" scoped>

.sp_wrap {
  width: 1200px;
  height: auto;
  margin: 50px auto;

  ul {
    width: 1200px;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-around;
  }

  li {
    width: calc(1200px / 2 - 20px);
    height: auto;
    background: #f5f5f5;
    margin: 30px 0;
    padding-bottom: 20px;
    color: #666;
    font-size: 16px;
    line-height: 1.8;

    video,
    img.poster-img {
      width: calc(1200px / 2 - 20px);
      height: 330px;
      object-fit: contain;
    }

    div {
      padding: 0 30px;
    }

    .sp_title {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 6px 0 0px;
      font-size: 20px;
      color: #063358;
      cursor: pointer;
    }

    .sp_title-title {
      max-height: 75px;
      flex: 1;
      padding: 0;
      margin-right: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .sp_title-copy {
      text-align: right;
      min-width: 60px;
      padding: 0;
      font-size: 14px;
      text-decoration: underline;
      color: #00a4ff;
    }

    .sp_desc {
      margin-top: 8px;
      height: 60px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .sp_time {
      margin-top: 10px;
      text-align: right;
      font-size: 14px;
    }
  }
}
.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cpzy/video.vue